import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import WhyRicohBackground from '../../static/img/why-back.jpg';
import {
  MarkdownRemarkFrontmatterReasonsList as ReasonProps,
  WhyR360ToursQuery,
} from '../../types/graphql-types';
import { useTransformNode } from '../hooks/useTransformer';

const WhyRicohBackgroundDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #033969;
  background-image: url(${WhyRicohBackground});
  background-repeat: repeat;
  background-attachment: scroll;
  background-position: center top;
  background-size: cover;
`;

const ReasonListDiv = styled.div`
  display: grid;
  grid-template-columns: auto auto;
`;

const ReasonImageDiv = styled.div`
  margin-right: 25px;
  @media (max-width: 768px) {
    display: none;
  }
`;

const ReasonHeader = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  color: #fff;
`;

const ReasonSubText = styled.p`
  margin-bottom: 5px 0;
  font-size: 16px;
  font-weight: 200;
  color: #fff;
  @media (max-width: 768px) {
    margin-top: 5px;
  }
`;

const MainHeaderText = styled.h2`
  margin: 0;
  font-size: 36px;
  font-weight: 200;
  line-height: 44px;
  color: #fff;
  text-align: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MainSubText = styled.h3`
  margin: 20px 0 50px 0;
  font-size: 28px;
  font-weight: 200;
  color: #fff;
  text-align: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

const WrapperDiv = styled.div`
  align-self: center;
  width: 80%;
  max-width: 1000px;
  padding: 50px 0;
  @media (max-width: 768px) {
    width: 80%;
    padding: 40px 0 0;
  }
`;

const TextContentDiv = styled.div`
  width: 80%;
  margin-bottom: 50px;
  @media (max-width: 768px) {
    width: 95%;
    margin-bottom: 20px;
  }
`;

const RenderListDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    grid-template-columns: none;
  }
`;

const WHY_RICOH360_TOURS_QUERY = graphql`
  query WhyR360Tours {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "why-r360-tours" } } }
    ) {
      edges {
        node {
          id
          fields {
            language
            country
          }
          frontmatter {
            templateKey
            mainHeaderText
            mainSubText
            reasonsList {
              reasonHeader
              reasonSubText
              reasonIcon {
                publicURL
              }
            }
          }
        }
      }
    }
  }
`;

const renderReasonsList = (reasonsList: ReasonProps[]) => {
  return reasonsList.map((item: ReasonProps, i: number) => {
    const reasonIconPath = item.reasonIcon?.publicURL;
    return (
      <ReasonListDiv key={i}>
        <ReasonImageDiv>
          <img src={reasonIconPath ?? ''} />
        </ReasonImageDiv>
        <TextContentDiv>
          <ReasonHeader>{item.reasonHeader}</ReasonHeader>
          <ReasonSubText>{item.reasonSubText}</ReasonSubText>
        </TextContentDiv>
      </ReasonListDiv>
    );
  });
};

const WhyR360Tours: React.FC = () => {
  const data = useStaticQuery<WhyR360ToursQuery>(WHY_RICOH360_TOURS_QUERY);
  const { frontmatter } = useTransformNode(data);

  const reasonsList = frontmatter?.reasonsList;

  return (
    <>
      <WhyRicohBackgroundDiv>
        <WrapperDiv>
          <MainHeaderText>{frontmatter?.mainHeaderText}</MainHeaderText>
          <MainSubText>{frontmatter?.mainSubText}</MainSubText>
          <RenderListDiv>
            {renderReasonsList(reasonsList as ReasonProps[])}
          </RenderListDiv>
        </WrapperDiv>
      </WhyRicohBackgroundDiv>
    </>
  );
};

export default WhyR360Tours;
